import $ from 'jquery';
import {Modal} from "bootstrap";


export function openModal(id, opts) {
    let options = opts || {};

    return new Promise((resolve, reject) => {
        const element = document.getElementById(id);
        const modal = new Modal(element, {});
        modal.show();
        let which = 'denied';

        let title = element.querySelector('.modal-title');
        let body = element.querySelector('.modal-body');
        if (title && options.title) title.textContent = options.title;
        if (body && options.message && !options.html) body.textContent = options.message;
        if (body && options.message && options.html) body.innerHTML = options.message;

        $(element).find('.js-yes-button').text(options.yesText ? options.yesText : 'Ja');
        $(element).find('.js-no-button').text(options.noText ? options.noText : 'Nein');

        $(element).find('[data-bs-yes="modal"]').on('click', ev => {
            which = 'accepted';
            modal.hide();
        });

        element.addEventListener('hidden.bs.modal', ev => {
            resolve(which);
        });
    });
}
